/* global $:true module:true Flickity:true Foundation:true */
// import $ from 'jquery';
const ZERO = 0;
const SLIDE_CELL_SELECTOR = '.slide-cell .video-block__iframe';
const DOTS_SELECTOR = '.flickity-page-dots';
const DOTS_WRAPPER_CLASS = 'flickity-page-dots-wrapper';
const AUTOPLAY_DELAY = 6000;

function setSlideHeights() {
	$('.block-slider')
		.each(function ReduceSliderHeightFn () {
			const slider = $(this);
			let height = 0;

			$(slider).find('.slide-cell')
				.css('height', 'auto');

			$(slider).find('.slide-cell')
				.each(function FindSlideHeight () {
					const cell = $(this);
					const cellHeight = cell.height();
					if (cellHeight > height) {
						height = cellHeight;
					}
				});

			$(slider).find('.slide-cell')
				.css('height', height);

			$(slider).addClass('height-set');

		});
}

function AddDotsWrappingElement() {
	$('.block-slider')
		.each(function(){
			var element = this;

			//added a timeout as dots weren't being added correctly if multiple sliders on a page
			setTimeout(function(){

				if ($(element).find('.' + DOTS_WRAPPER_CLASS).length == 0) {
					var el = $(element).find(DOTS_SELECTOR).detach();
					var div = document.createElement('div');
					div.className = DOTS_WRAPPER_CLASS;
					$(element).append(div);
					$(element).find('.' + DOTS_WRAPPER_CLASS).append(el);
				}
			}, 200);
		});
}

function setupSliders() {
	$('.block-slider')
		.each(function SetupSlider () {
			const slider = $(this);
			const sliderElement = $(slider).get(ZERO);
			const autoPlay = $(slider).attr('data-auto-play') === 'true' ? AUTOPLAY_DELAY : false;

			// Legacy edge native video player not playable with mouse inside flickity with dragging enabled
			const draggableEnabled = isWebAnimationSupported();

			const FlickityOptions = {
					autoPlay: autoPlay,
					wrapAround: true,
					freeScroll: false,
					bgLazyLoad: true,
					adaptiveHeight: false,
					draggable: draggableEnabled,
                    dragThreshold: 10,
					contain: true,
					cellAlign: 'left',
					groupCells: '100%',
					arrowShape: 'M74.38,92.74a4.24,4.24,0,1,1-6,6c-.5-.47-1-1-1.45-1.46l-8.87-8.86L31.94,62.29,23.68,54a9,9,0,0,1-1.88-2.21c-1-2-.12-3.9,1.32-5.34L43,26.63,66.08,3.52c.71-.71,1.41-1.42,2.12-2.12,2.24-2.2,6.14-1.73,7.2,1.47s-2.58,5.9-4.62,7.94l-24.6,24.6-11,11-3,3c-.09.09-.56.43-.57.56s.07.08.14.22.58.58.8.81L34,52.35l4.36,4.36L50.88,69.24,73.1,91.46Z',
					on: {
						change: function() {
							$(SLIDE_CELL_SELECTOR).each(function() {
								if (typeof($(this)[0].contentWindow) !== 'undefined') {
									$(this)[0].contentWindow.postMessage(
										'{"event":"command","func":"pauseVideo","args":""}',
										'*');
								}
							});
						},
						ready : function() {
							AddDotsWrappingElement();
						}
					}
			};

			var flick = new Flickity(sliderElement, FlickityOptions);
		});

	$(window).resize(() => {
		setSlideHeights();
	});
}

// Test designed to isolate Legacy Edge
function isWebAnimationSupported() {
	return ('animate' in document.documentElement);
}

export default function exec() {
	setSlideHeights();
	setupSliders();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/carousel-block/blocks.js